import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Close = (props: IconProps) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
    fill="white"
    stroke="#899396"
    _hover={{ fill: '#C29F6B', stroke: 'white', '&>path': { stroke: 'white' } }}
  >
    <circle cx="12" cy="12" r="11.5" />
    <path d="M14.8359 9.17188L9.17908 14.8287" stroke="#899396" strokeLinecap="round" />
    <path d="M14.8359 14.8281L9.17908 9.17127" stroke="#899396" strokeLinecap="round" />
  </Icon>
);
